import { BASE_AUTH_API } from '@/core/api-config';
import { LoginRequest, LoginResponse } from "@/core/auth/types";
import { ApiErrorMiddleware } from '@/core/api-error-middleware';

export class AuthApi {
  constructor(
    private readonly baseUrl: string = BASE_AUTH_API,
  ) {}

  // Login is the only endpoint that doesn't require authentication
  async login(request: LoginRequest): Promise<LoginResponse> {
    const response = await fetch(`${this.baseUrl}/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (response.status === 401) {
      await response.json().catch(() => ({}));
      throw new Error('Invalid email or password. Please check your credentials and try again.');
    }

    if (!response.ok) {
      const errorMessage = await ApiErrorMiddleware.handleErrorResponse(
        response,
        'Auth API',
        '/signin'
      );
      throw new Error(errorMessage);
    }

    const data = await response.json();

    // Show success toast in debug mode
    ApiErrorMiddleware.showSuccessToast('Auth API', 'Login successful');

    return {
      token: data.token,
      // Support both camelCase and PascalCase field names from API
      accountId: data.accountId || data.AccountId,
      operatorId: data.operatorId || data.OperatorId,
      distributorId: data.distributorId || data.DistributorId
    };
  }

  // Logout is now just a no-op since we only clear local tokens
  async logout(): Promise<void> {
    // No API call needed, just return
    return;
  }
}